import type { DraftItem } from '../types.local';
import { keyOf } from '../types.local';

// prev와 next 사이 값(없으면 append용 10 증가)
export function between(prev?: number | null, next?: number | null) {
    const P = typeof prev === 'number' ? prev : null;
    const N = typeof next === 'number' ? next : null;
    // 형제가 아무도 없으면 10
    if (P == null && N == null) return 10;
    // 앞이 없고 뒤만 있으면: 뒤의 절반 지점
    if (P == null) return N! / 2;
    // 뒤가 없으면: 앞에서 10 더 (append)
    if (N == null) return P + 10;
    // 둘 다 있으면: 정확히 중간
    return (P + N) / 2
}

// 특정 부모의 **드래프트(추가분만)** 형제들을 10,20,30…로 정규화 (로컬용)
export function normalizeDraftSiblings10Step(all: DraftItem[], parentNodeId: string | null) {
    const sibs = all.filter(
        (x) => (x.parentNodeId ?? null) === (parentNodeId ?? null) && (x as any)._kind === 'ADDED' && !x.isDeleted,
    );
    sibs.sort((a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0));
    sibs.forEach((it, idx) => {
        it.orderIndex = (idx + 1) * 10;
    });
    return sibs.map((it) => ({ key: keyOf(it), orderIndex: it.orderIndex! }));
}
